
import React, { useEffect, useState, useCallback, useRef, Fragment } from "react";
import axios from 'axios';
import moment from 'moment';
import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Spin, Menu, Upload, Radio, Modal, Skeleton, Select, Space, List, Divider, InputNumber, DatePicker, Carousel, Dropdown, Checkbox } from "antd";

import {
    SaveOutlined, EyeOutlined
} from "@ant-design/icons";
import { formatCurrency } from '../common/Format';
import HtmlEditor from '../common/HtmlEditor/HtmlEditor';
import swal from "sweetalert";
import axiosClient from "../../api/axios";

const FormTemplateEN = () => {

    const [loadingContract, setLoadingContract] = useState(false);
    const [openModalContract, setOpenModalContract] = useState(false);
    const token = localStorage.getItem('token');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const handleOkContract = () => {
        setLoadingContract(true);
        setTimeout(() => {
            setLoadingContract(false);
            setOpenModalContract(false);
        }, 3000);
    }
    const handleCancelContract = () => {

        setLoadingContract(false);
        setOpenModalContract(false);
    }
    const showModalContract = (e) => {
        setOpenModalContract(true)
    }
    // const lineBreak = (str) => {
    //     const replaceText = String(str).replace('+', '\n').replace('+', '\n')
    //     return replaceText
    // }
    const [form] = Form.useForm()



    const [dataPriceListInfo, setDataPriceListInfo] = useState([]);

    
    const testString = `<table style="border-collapse: collapse; width: 100%; border-width: 2px; background-color: #ced4d9; height: 163.156px; margin-left: auto; margin-right: auto;" border="1"><colgroup><col style="width: 99.9178%;"></colgroup>
<tbody>
<tr style="height: 163.156px;">
<td style="border-width: 2px;">
<p style="text-align: center;"><strong>Thỏa thuận của người chơi</strong></p>
<p style="text-align: center;">Bao gồm gi&aacute; định rủi ro v&agrave; thỏa thuận về miễn trừ bồi thường</p>
<p style="text-align: center;">Bằng việc k&yacute; kết thỏa thuận n&agrave;y, bạn sẽ từ bỏ một số quyền lợi hợp ph&aacute;p, bao gồm cả quyền khởi kiện hoặc y&ecirc;u cầu bồi thường trong trường hợp tai nạn</p>
<p style="text-align: center;"><strong>VUI L&Ograve;NG ĐỌC KỸ</strong></p>
</td>
</tr>
</tbody>
</table>
<table style="border-collapse: collapse; width: 100%; height: 120px; border-width: 1px;" border="1"><colgroup><col style="width: 51.7695%;"><col style="width: 27.1605%;"><col style="width: 21.07%;"></colgroup>
<tbody>
<tr style="height: 94.9688px;">
<td>
<p>Họ t&ecirc;n</p>
<p style="text-align: center;">{FullName}</p>
</td>
<td>
<p>Số CMND/ hộ chiếu</p>
<p style="text-align: center;">{IDCard}</p>
</td>
<td>
<p>Quốc tịch</p>
<p style="text-align: center;">{Nationality}</p>
</td>
</tr>
</tbody>
</table>
<table style="border-collapse: collapse; width: 100%; height: 100px; border-width: 1px;" border="1"><colgroup><col style="width: 78.9301%;"><col style="width: 21.0699%;"></colgroup>
<tbody>
<tr>
<td>
<p>Địa chỉ</p>
<p style="text-align: center;">{Address}</p>
</td>
<td>
<p>Ng&agrave;y th&aacute;ng năm sinh</p>
<p style="text-align: center;">{BirthDay}</p>
</td>
</tr>
</tbody>
</table>
<table style="border-collapse: collapse; width: 100%; height: 94.9688px;" border="1"><colgroup><col style="width: 26.0074%;"><col style="width: 26.0913%;"><col style="width: 26.9136%;"><col style="width: 20.9877%;"></colgroup>
<tbody>
<tr style="height: 94.9688px;">
<td>
<p>Số điện thoại</p>
<p style="text-align: center;">{Phone}</p>
</td>
<td>
<p>Email</p>
<p style="text-align: center;">{Email}</p>
</td>
<td>
<p>T&ecirc;n người li&ecirc;n hệ khẩn cấp</p>
<p style="text-align: center;">{EmergencyContactName}</p>
</td>
<td>
<div class="ant-col ant-col-6 ant-col-xs-24 ant-col-xl-6">
<div class="ant-row">
<div class="ant-col ant-col-24">
<div class="ant-form-item">
<div class="ant-row ant-form-item-row">
<div class="ant-col ant-col-24 ant-form-item-control">
<div class="ant-form-item-control-input">&nbsp;</div>
</div>
</div>
</div>
</div>
</div>
</div>
<div class="ant-col ant-col-6 ant-col-xs-24 ant-col-xl-6">
<div class="ant-row">
<div class="ant-col ant-col-24">Số điện thoại li&ecirc;n hệ khẩn cấp</div>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24" style="text-align: center;">{EmergencyContactPhone}</div>
</div>
</div>
</td>
</tr>
</tbody>
</table>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24">Bản thỏa thuận n&agrave;y phải được đọc, hiểu v&agrave; k&yacute; bởi tất cả mọi người tham gia tr&ograve; chơi, người lớn v&agrave; trẻ vị th&agrave;nh ni&ecirc;n ( dưới 18 tuổi) v&agrave; bởi cha mẹ hoặc người gi&aacute;m hộ( được hiểu như &ldquo; cha mẹ&rdquo;) của mỗi người chơi vị th&agrave;nh ni&ecirc;n. Cha mẹ k&yacute; cho bản th&acirc;n họ v&agrave; k&yacute; đại diện cho trẻ vị th&agrave;nh ni&ecirc;n. Người chơi kh&ocirc;ng thể tham gia v&agrave;o bất cứ tr&ograve; chơi mạo hiểm n&agrave;o tại Datanla của Dalattourist nếu kh&ocirc;ng k&yacute; v&agrave;o bản thỏa thuận n&agrave;y</div>
<div class="ant-col ant-col-24">Chủ thể của bản thỏa thuận n&agrave;y l&agrave; C&ocirc;ng ty Cổ phần Du lịch L&acirc;m Đồng v&agrave; chủ sở hữu, người đại diện, c&aacute;n bộ, quản l&yacute;, nh&acirc;n vi&ecirc;n v&agrave; c&aacute;c c&ocirc;ng ty li&ecirc;n kết ( gọi chung l&agrave; Dalattourist) v&agrave; những người k&yacute; t&ecirc;n dưới đ&acirc;y ( &ldquo;Người chơi&rdquo;)</div>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24">
<div class="ant-col ant-col-24"><strong>M&ocirc; tả hoạt động</strong></div>
<div class="ant-col ant-col-24">Datanla Adventure cho bạn cơ hội kh&aacute;m ph&aacute; v&agrave; s&aacute;ng tạo trong một m&ocirc;i trường thi&ecirc;n nhi&ecirc;n xinh đẹp của Đ&agrave; lạt. C&aacute;c hoạt động dưới đ&acirc;y v&agrave; c&aacute;c yếu tố c&oacute; thể bao gồm trong c&aacute;c hoạt động hiện c&oacute; tại Datanla Adventures:</div>
<div class="ant-col ant-col-24"><strong>1. Cayyoning.</strong>&nbsp;Trải nghiệm cảm gi&aacute;c hồi hộp khi đi xuống hẻm n&uacute;i Datanla xuy&ecirc;n qua h&agrave;ng loạt th&aacute;c nước. Hoạt động n&agrave;y bao gồm đu d&acirc;y xuống v&aacute;ch n&uacute;i, nhảy v&aacute;ch đ&aacute;, trượt th&aacute;c v&agrave; trượt zipline qua th&aacute;c. Người chơi sẽ trải nghiệm cảm gi&aacute;c hồi hộp, thử th&aacute;ch v&agrave; kiệt sức khi xuy&ecirc;n qua c&aacute;c v&aacute;ch n&uacute;i v&agrave; th&aacute;c nước Datanla.</div>
<div class="ant-col ant-col-24"><strong>2. Zip Lines.</strong>&nbsp;Người chơi sẽ trượt băng qua ngọn c&acirc;y tr&ecirc;n t&aacute;n rừng. Người chơi sẽ phải đối mặt với nỗi sợ về độ cao, về tốc độ nhanh v&agrave; nguy cơ phải chấp nhận với thử th&aacute;ch mới.</div>
<div class="ant-col ant-col-24"><strong>3. High Ropes Course.</strong>Một loạt c&aacute;c thử th&aacute;ch bao gồm đi cầu d&acirc;y, giữ thăng bằng, nhảy Tarzan, đu d&acirc;y v&agrave; vượt c&aacute;c chướng ngại vật tr&ecirc;n c&acirc;y kh&aacute;c trong rừng th&ocirc;ng Datanla. Người chơi sẽ đối mặt với h&agrave;ng loạt thử th&aacute;ch trải rộng qua c&aacute;c v&ograve;ng chơi từ dễ đến kh&oacute;, từ thấp đến cao.</div>
<div class="ant-col ant-col-24"><strong>4.C&aacute;c hoạt động kh&aacute;c.&nbsp;</strong>Người chơi c&oacute; thể tham gia v&agrave;o c&aacute;c hoạt động trong khi c&oacute; mặt tại Datanla Adventures đ&ograve;i hỏi phải c&oacute; thể lực, rủi ro cho bản th&acirc;n v&agrave; c&aacute;c nguy cơ kh&aacute;c vốn c&oacute; đối với hoạt động ngo&agrave;i trời. C&aacute;c hoạt động kh&aacute;c bao gồm nhưng kh&ocirc;ng giới hạn việc bước l&ecirc;n v&agrave; bước xuống đường trượt, bơi lội, leo l&ecirc;n v&agrave; leo xuống cầu thang, bậc cấp, v&aacute;ch đ&aacute; hay những triền dốc&hellip;</div>
<div class="ant-col ant-col-24"><strong>C&aacute;c quan t&acirc;m về y tế</strong></div>
<div class="ant-col ant-col-24">Datanla Adventures được thiết kế cho những người chơi c&oacute; khả năng di chuyển, c&oacute; sức mạnh v&agrave; sức khỏe tốt. B&eacute;o ph&igrave;, huyết &aacute;p cao, bệnh tim v&agrave; mạch v&agrave;nh, c&aacute;c vấn đề phổi, vi&ecirc;m khớp, g&acirc;n, c&aacute;c vấn đề về cơ xương khớp kh&aacute;c c&oacute; thể ảnh hưởng đến sự an to&agrave;n v&agrave; sức khỏe của người chơi. C&aacute;c vần đề về t&acirc;m l&yacute; cũng c&oacute; khả năng l&agrave;m tăng nguy cơ rủi ro vốn c&oacute; của việc trải nghiệm v&agrave; dẫn đến người chơi g&acirc;y nguy hiểm cho ch&iacute;nh họ v&agrave; cho người kh&aacute;c. Người chơi với c&aacute;c vấn đề y tế tiềm ẩn khiến họ c&oacute; nguy cơ bị thương hoặc bị bệnh cao hơn khi tham gia tại Datanla Adventure phải xem x&eacute;t kỹ c&aacute;c nguy cơ trước khi chọn tham gia v&agrave; phải th&ocirc;ng b&aacute;o cho nh&acirc;n vi&ecirc;n Dalattourist biết trước khi bắt đầu tr&ograve; chơi hoặc tại bất cứ thời điểm n&agrave;o trong suốt h&agrave;nh tr&igrave;nh. Dalattourist c&oacute; quyền loại bất cứ người chơi n&agrave;o v&igrave; l&yacute; do y tế, an to&agrave;n hoặc c&aacute;c l&yacute; do kh&aacute;c.</div>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24">
<table style="border-collapse: collapse; width: 100%; height: 99px; border-width: 2px; background-color: #ced4d9;" border="1"><colgroup><col style="width: 100%;"></colgroup>
<tbody>
<tr style="height: 99px;">
<td style="border-width: 2px;">
<p>Vui l&ograve;ng liệt k&ecirc;&nbsp;<u>bất cứ c&aacute;c VẤN ĐỀ Y TẾ hiện nay hoặc trước đ&acirc;y&nbsp;</u>c&oacute; thể ảnh hưởng đến sự an to&agrave;n của Người chơi hoặc cho người kh&aacute;c:</p>
<p>&nbsp;{Note}</p>
<p>&nbsp;</p>
</td>
</tr>
</tbody>
</table>
<div class="ant-col ant-col-24">
<div class="ant-row">
<div class="ant-col ant-col-22">&nbsp;</div>
<div class="ant-col ant-col-22">Do những rủi ro v&agrave; cần c&oacute; sự nỗ lực với c&aacute;c hoạt động của Datanla Adventures, n&ecirc;n những hoạt động n&agrave;y kh&ocirc;ng ph&ugrave; hợp với phụ nữ mang thai. Vui l&ograve;ng đ&aacute;nh dấu v&agrave;o đ&acirc;y để x&aacute;c nhận hiện tại bạn kh&ocirc;ng c&oacute; thai: {checkbox}</div>
</div>
</div>
<div class="ant-col ant-col-24">
<div class="ant-row">
<div class="ant-col ant-col-22">C&aacute;c hoạt động mạo hiểm tại Datanla Adventures đ&ograve;i hỏi năng lực tinh thần v&agrave; khả năng tập trung của bạn. Nghi&ecirc;m cấm việc sử dụng bất kỳ loại chất k&iacute;ch th&iacute;ch, chất g&acirc;y nghiện hoặc chất c&oacute; cồn khi tham gia. Vui l&ograve;ng đ&aacute;nh dấu v&agrave;o đ&acirc;y để x&aacute;c nhận rằng bạn kh&ocirc;ng bị ảnh hưởng bởi chất c&oacute; cồn hoặc chất k&iacute;ch th&iacute;ch, chất g&acirc;y nghiện .<span class="ant-checkbox">{checkbox}</span></div>
</div>
</div>
<div class="ant-col ant-col-24">C&aacute;c rủi ro tiềm ẩn kh&aacute;c</div>
<div class="ant-col ant-col-24">V&ocirc; số c&aacute;c nguy cơ tiềm ẩm đối với c&aacute;c hoạt động mạo hiểm tại Datanla. Địa h&igrave;nh cho c&aacute;c hoạt động mạo hiểm Datanla bao gồm địa h&igrave;nh đ&aacute;, rừng, v&aacute;ch n&uacute;i, hẻm n&uacute;i, s&ocirc;ng, suối, th&aacute;c ghềnh v&agrave; c&aacute;c lo&agrave;i động thực vật c&oacute; hại. Những rủi ro kh&ocirc;ng thể được loại bỏ m&agrave; kh&ocirc;ng hủy hoại gi&aacute; trị m&ocirc;i trường v&agrave; t&iacute;nh độc đ&aacute;o của những hoạt động mạo hiểm Datanla bao gồm nguy cơ bị thương v&igrave; l&yacute; do t&eacute; ng&atilde;, va chạm với người chơi kh&aacute;c hoặc c&aacute;c vật cố định, di chuyển về c&aacute;c điểm của h&agrave;nh tr&igrave;nh, tiếp x&uacute;c với thời tiết, nước, động thực vật, c&agrave;nh c&acirc;y rơi, vật thể rơi, cầu thang v&agrave; lối đi trơn trượt, tiếp cận độ cao, qu&aacute; sức, lo lắng,thiết bị bị lỗi, sử dụng hoặc điều chỉnh thiết bị sai c&aacute;ch, v&agrave; những l&yacute; do kh&aacute;c. Những rủi ro n&agrave;y c&oacute; thể dẫn đến việc hư hỏng t&agrave;i sản, bị thương hoặc tử vong. Những rủi ro thể chất từ những vết xước nhỏ v&agrave; vết bầm t&iacute;m đến những vết đốt v&agrave; cắn, g&atilde;y xương, bong g&acirc;n, tổn thương thần kinh, chấn thương nghi&ecirc;m trọng, t&ecirc; liệt hoặc thậm ch&iacute; tử vong. Rủi ro tinh thần bao gồm từ cảm gi&aacute;c tổn thương đến hoảng loạn v&agrave; chấn thương t&acirc;m l&yacute; ( v&iacute; dụ sợ độ cao) Chấn thương c&oacute; thể l&agrave; kết quả của việc thực hiện c&aacute;c hoạt động, hậu quả của thiết kế kết cấu hoặc sự sai s&oacute;t, do c&aacute;c mối nguy m&ocirc;i trường ( bao gồm rừng, c&acirc;y, thi&ecirc;n nhi&ecirc;n hoang d&atilde;), l&agrave; hậu quả của việc đ&aacute;nh gi&aacute; sai hoặc sự sơ suất của nh&acirc;n vi&ecirc;n hoặc người chơi. Trong tất cả c&aacute;c trường hợp đ&oacute;, những rủi ro cố hữu v&agrave; những rủi ro kh&aacute;c phải được chấp nhận bởi người đăng k&yacute; tham gia.</div>
<div class="ant-col ant-col-24">Với việc xem x&eacute;t c&aacute;c hoạt động m&agrave; t&ocirc;i, hoặc nh&oacute;m của t&ocirc;i thỏa thuận với Dalattourist, t&ocirc;i người chơi k&yacute; t&ecirc;n dưới đ&acirc;y v&agrave; phụ huynh của trẻ vị th&agrave;nh ni&ecirc;n, đồng &yacute; những điều khoản sau:</div>
<div class="ant-col ant-col-24">1. T&ocirc;i đ&atilde; hiểu bản chất của c&aacute;c hoạt động m&agrave; t&ocirc;i sẽ li&ecirc;n quan như m&ocirc; tả ở tr&ecirc;n.</div>
<div class="ant-col ant-col-24">2. T&ocirc;i đồng &yacute; tu&acirc;n theo mọi hướng dẫn của Dalattourist, bao gồm hướng dẫn tr&ecirc;n bảng v&agrave; hướng dẫn bằng lời n&oacute;i của nh&acirc;n vi&ecirc;n Dalattourist.</div>
<div class="ant-col ant-col-24">3. T&ocirc;i đồng &yacute; mặc đủ c&aacute;c trang thiết bị an to&agrave;n trong suốt thời gian tham gia tr&ograve; chơi v&agrave; sử dụng c&aacute;c thiết bị theo đ&uacute;ng hướng dẫn qui định v&agrave; lời hướng dẫn của nh&acirc;n vi&ecirc;n.</div>
<div class="ant-col ant-col-24">4. T&ocirc;i đ&atilde; th&ocirc;ng b&aacute;o đầy đủ bằng văn bản cho Dalattourist về những vấn đề y tế c&oacute; nguy cơ l&agrave;m cho t&ocirc;i bị ốm hoặc bị thương do việc tham gia v&agrave;o c&aacute;c hoạt động mạo hiểm tại Datanla g&acirc;y ra .</div>
<div class="ant-col ant-col-24">5. T&ocirc;i đ&atilde; được biết c&aacute;c y&ecirc;u cầu về chiều cao, c&acirc;n nặng, độ tuổi để tham gia v&agrave;o c&aacute;c hoạt động mạo hiểm m&agrave; t&ocirc;i tham gia v&agrave; t&ocirc;i đ&aacute;p ứng được với c&aacute;c y&ecirc;u cầu đ&oacute;</div>
<div class="ant-col ant-col-24">6. T&ocirc;i kh&ocirc;ng bị ảnh hưởng bởi bất kỳ thứ thuốc, chất k&iacute;ch th&iacute;ch, chất g&acirc;y nghiện, hoặc c&aacute;c loại c&oacute; cồn n&agrave;o.</div>
<div class="ant-col ant-col-24">7. T&ocirc;i kh&ocirc;ng mang thai.</div>
<div class="ant-col ant-col-24">8. T&ocirc;i hiểu sẽ c&oacute; thể c&oacute; những hư hại về t&agrave;i sản, bị thương hoặc tử vong li&ecirc;n quan đến c&aacute;c hoạt động n&agrave;y v&agrave; chắc chắn rằng những rủi ro như m&ocirc; tả tr&ecirc;n đ&acirc;y l&agrave; vấn đề cố hữu của hoạt động mạo hiểm v&agrave; kh&ocirc;ng thể giảm hoặc loại bỏ ho&agrave;n to&agrave;n khỏi hoạt động mạo hiểm.</div>
<div class="ant-col ant-col-24">9. T&ocirc;i biết v&agrave; tự nguyện chấp nhận những rủi ro về hư hại t&agrave;i sản, bệnh tật, chấn thương thậm tr&iacute; tử vong li&ecirc;n quan đến c&aacute;c hoạt động n&agrave;y, c&aacute;c rủi ro vốn c&oacute; cũng như c&aacute;c kh&iacute;a cạnh kh&aacute;c , cho d&ugrave; đ&atilde; được m&ocirc; tả ở tr&ecirc;n hay kh&ocirc;ng, bao gồm cả những việc c&oacute; thể do h&agrave;nh vi bất cẩn hoặc thiếu s&oacute;t của những người chơi kh&aacute;c.</div>
<div class="ant-col ant-col-24">10. T&ocirc;i hiểu rằng Dalattourist c&oacute; thể từ chối cung cấp dịch vụ cho c&aacute; nh&acirc;n hoặc đại l&yacute; được coi l&agrave; c&oacute; mối nguy cho ch&iacute;nh họ hoặc từ những người kh&aacute;c. Dalattourist c&oacute; thể thay đổi c&aacute;c điều kiện đ&atilde; c&ocirc;ng bố của họ cho người chơi t&ugrave;y theo c&aacute;c trường hợp Dalattourist thấy ph&ugrave; hợp.</div>
<div class="ant-col ant-col-24">11. T&ocirc;i chấp nhận chịu tr&aacute;ch nhiệm về những chi ph&iacute; c&oacute; thể ph&aacute;t sinh li&ecirc;n quan tới bệnh tật hoặc thương t&iacute;ch do việc tham gia c&aacute;c hoạt động mạo hiểm của Dalattourist g&acirc;y ra, bao gồm c&aacute;c chi ph&iacute; di tản, nhập viện v&agrave; điều trị.</div>
<div class="ant-col ant-col-24">12. T&ocirc;i xin đảm bảo sự v&ocirc; hại v&agrave; miễn đ&ograve;i bồi thường với Dalattourist v&agrave; c&aacute;c chủ thể của c&aacute;c t&agrave;i sản li&ecirc;n quan đến c&aacute;c hoạt động được thực hiện ( &ldquo;C&aacute;c b&ecirc;n được miễn trừ&rdquo;) v&agrave; đồng &yacute; kh&ocirc;ng kiện họ v&igrave; bất cứ tr&aacute;ch nhiệm ph&aacute;p l&yacute; n&agrave;o đối với việc khiếu nại c&oacute; thể ph&aacute;t sinh hoặc c&oacute; li&ecirc;n quan tới việc t&ocirc;i tham gia v&agrave;o tr&ograve; chơi. T&ocirc;i x&aacute;c nhận rằng Dalattourist sẽ kh&ocirc;ng chịu tr&aacute;ch nhiệm trực tiếp hoặc gi&aacute;n tiếp về những tổn thất, thương t&iacute;ch hoặc tử vong xuất ph&aacute;t từ hoặc li&ecirc;n quan đến c&aacute;c hoạt động v&agrave; t&ocirc;i từ bỏ bất kỳ hoặc tất cả c&aacute;c khiếu nại đối với Dalattourist trong kh&iacute;a cạnh n&agrave;y.</div>
<div class="ant-col ant-col-24">13. Đối với c&aacute; nh&acirc;n t&ocirc;i, gia đ&igrave;nh, người thừa kế, người đại diện v&agrave; bất cứ người n&agrave;o kh&aacute;c th&ocirc;ng qua t&ocirc;i, t&ocirc;i từ bỏ, giữ sự v&ocirc; hại v&agrave; miễn đ&ograve;i bồi thường với C&aacute;c b&ecirc;n được miễn trừ cho bất kỳ khoản tiền n&agrave;o c&oacute; thể phải trả cho bất kỳ người n&agrave;o v&igrave; l&yacute; do c&oacute; bất kỳ sự mất m&aacute;t, thương t&iacute;ch hoặc mất t&iacute;ch m&agrave; t&ocirc;i c&oacute; thể chịu khi tham gia v&agrave;o tr&ograve; chơi, v&agrave; cho tất cả c&aacute;c chi ph&iacute; li&ecirc;n quan đến việc bảo vệ bất kỳ khiếu nại n&agrave;o như vậy. T&ocirc;i hiểu rằng khoản bồi thường n&agrave;y c&oacute; nghĩa t&ocirc;i chấp nhận chịu tr&aacute;ch nhiệm về việc trả bất kỳ chi ph&iacute; n&agrave;o bao gồm cả ph&iacute; luật sư c&oacute; thể c&oacute; từ việc khiếu nại đối với c&aacute;c b&ecirc;n được miễn trừ.</div>
<div class="ant-col ant-col-24">14. Dalattourist c&oacute; quyền sử dụng video, h&igrave;nh ảnh của người chơi cho việc tuy&ecirc;n truyền , quảng b&aacute; hoặc c&aacute;c mục đ&iacute;ch kh&aacute;c trong tương lai, v&agrave; người chơi ( v&agrave; phụ huynh) đồng &yacute; với việc sử dụng đ&oacute; m&agrave; kh&ocirc;ng đ&ograve;i bồi thường.</div>
<div class="ant-col ant-col-24">15. T&ocirc;i đồng &yacute; việc Dalattourist c&oacute; thể li&ecirc;n hệ với t&ocirc;i sử dụng email v&agrave; số điện thoại của t&ocirc;i v&agrave;o việc marketing hoặc những mục đ&iacute;ch kh&aacute;c.</div>
<div class="ant-col ant-col-24">16. T&ocirc;i đồng &yacute; rằng ph&aacute;p luật Việt Nam c&oacute; thể &aacute;p dụng trong thỏa thuận n&agrave;y v&agrave; c&aacute;c to&agrave; &aacute;n Việt Nam c&oacute; thẩm quyền trong bất kỳ tranh chấp n&agrave;o c&oacute; thể ph&aacute;t sinh giữa người chơi v&agrave; Dalattourist.</div>
<div class="ant-col ant-col-24">17. T&ocirc;i đồng &yacute; rằng bất cứ phần n&agrave;o trong thỏa thuận n&agrave;y cũng c&oacute; thể được t&ograve;a &aacute;n c&oacute; thẩm quyền x&eacute;t xử hợp lệ v&agrave; c&aacute;c phần kh&ocirc;ng x&eacute;t tới cũng vẫn hợp lệ v&agrave; c&oacute; hiệu lực. Nếu bất kỳ điều khoản n&agrave;o trong thỏa thuận n&agrave;y bị xem như kh&ocirc;ng c&oacute; hiệu lực hoặc kh&ocirc;ng thể thực thi th&igrave; điều khoản đ&oacute; sẽ được coi l&agrave; sửa đổi bằng c&aacute;ch giảm bớt hoặc giới hạn để c&oacute; hiệu lực v&agrave; để c&oacute; thể thi h&agrave;nh ở mức độ tối đa ph&ugrave; hợp với ph&aacute;p luật hiện h&agrave;nh.</div>
<div class="ant-col ant-col-24">T&ocirc;i đ&atilde; đọc, hiểu r&otilde; v&agrave; đồng &yacute; với c&aacute;c điều khoản của thỏa thuận n&agrave;y</div>
<div class="ant-col ant-col-24">
<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 46.5666%;"><col style="width: 31.2298%;"><col style="width: 22.1202%;"></colgroup>
<tbody>
<tr>
<td>
<p>K&yacute; t&ecirc;n</p>
<p style="text-align: center;">{Signature}</p>
</td>
<td>
<p>Tuổi</p>
<p style="text-align: center;">{Age}</p>
</td>
<td>
<p>Ng&agrave;y / Th&aacute;ng / Năm</p>
<p style="text-align: center;">{BirthDay}</p>
</td>
</tr>
</tbody>
</table>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24">Thỏa thuận bởi phụ huynh hoặc người gi&aacute;m hộ của trẻ vị th&agrave;nh ni&ecirc;n</div>
<div class="ant-col ant-col-24">T&ocirc;i l&agrave; phụ huynh hoặc người gi&aacute;m hộ của trẻ vị th&agrave;nh ni&ecirc;n k&yacute; t&ecirc;n ph&iacute;a tr&ecirc;n. T&ocirc;i đ&atilde; thảo luận về c&aacute;c điều khoản của thỏa thuận n&agrave;y với con t&ocirc;i v&agrave; c&aacute;c con t&ocirc;i chắc chắn rằng ch&uacute;ng đ&atilde; hiểu về thỏa thuận n&agrave;y v&agrave; ho&agrave;n to&agrave;n đồng &yacute; với c&aacute;c điều khoản của n&oacute;. T&ocirc;i cho ph&eacute;p con t&ocirc;i được tham gia v&agrave;o c&aacute;c hoạt động của Dalattourist. Chữ k&yacute; của t&ocirc;i dưới đ&acirc;y phản &aacute;nh sự chấp thuận của t&ocirc;i về việc miễn trừ ho&agrave;n to&agrave;n cho Dalattourist khỏi những khiếu nại m&agrave; t&ocirc;i c&oacute; thể c&oacute; v&agrave;, trong phạm vi tối đa được ph&aacute;p luật cho ph&eacute;p, được thay mặt những đứa trẻ miễn trừ cho Dalattourist khỏi bất cứ khiếu nại n&agrave;o đứa trẻ c&oacute; thể c&oacute;. T&ocirc;i cũng đồng &yacute; việc bồi thường cho b&ecirc;n được miễn trừ trong phạm vi tối đa được ph&aacute;p luật cho ph&eacute;p, cho bất cứ khiếu nại n&agrave;o của đứa trẻ hoặc bất cứ th&agrave;nh vi&ecirc;n n&agrave;o của gia đ&igrave;nh t&ocirc;i hoặc gia đ&igrave;nh đứa trẻ, ph&aacute;t sinh từ việc đứa trẻ tham gia v&agrave;o c&aacute;c hoạt động của nh&agrave; cung cấp.<strong>C&aacute;c thỏa thuận miễn trừ bồi thường n&agrave;y bao gồm c&aacute;c khiếu nại về sơ suất nhưng kh&ocirc;ng phải sơ suất lớn hoặc h&agrave;nh vi sai tr&aacute;i c&oacute; chủ &yacute;.</strong></div>
<div class="ant-col ant-col-24">&nbsp;</div>
<div class="ant-col ant-col-24">
<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 33.2777%;"><col style="width: 33.2777%;"><col style="width: 33.2777%;"></colgroup>
<tbody>
<tr>
<td>
<p>K&yacute; t&ecirc;n</p>
<p style="text-align: center;">{Signature}</p>
</td>
<td>
<p>T&ecirc;n viết hoa</p>
<p style="text-align: center;">{EmergencyContactName}</p>
</td>
<td>
<p>Ng&agrave;y / th&aacute;ng / năm</p>
<p style="text-align: center;">{BirthDay}</p>
</td>
</tr>
<tr>
<td>
<p>Địa chỉ</p>
<p style="text-align: center;">{Address}</p>
</td>
<td>
<p>Th&agrave;nh phố</p>
<p style="text-align: center;">{City}</p>
</td>
<td>
<p>Quốc gia</p>
<p style="text-align: center;">{Nationality}</p>
</td>
</tr>
<tr>
<td>
<p>Số ĐT</p>
<p style="text-align: center;">{Phone}</p>
</td>
<td>
<p>Email</p>
<p style="text-align: center;">{Email}</p>
</td>
<td>
<p>Số CMND/ Hộ Chiếu</p>
<p style="text-align: center;">{IDGuardian}</p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</div>
<div class="ant-col ant-col-24">&nbsp;</div>
   `

    const LoadDataPriceListInfo = () => {
        axiosClient.post('/CompanyInfomations/GetCompanyInfomationsAll', '', { headers: header }).then(res => {
            setDataPriceListInfo(res.data);
            setValue(res.data[0].Registeren);
            //console.log(arrTH(res.data[0].DeliveryTemplate))
        })
    }
    useEffect(() => {
        LoadDataPriceListInfo()
    }, [])
    const editorRef = useRef(null);
    const [value, setValue] = useState('');
    const [text, setText] = useState('');

    const onFinish = (values) => {

        axiosClient.post('CompanyInfomations/UpdateCompanyInfomations', {
            "ID": dataPriceListInfo[0].ID,
            "FullName": dataPriceListInfo[0].FullName,
            "Address": dataPriceListInfo[0].Address,
            "Phone": dataPriceListInfo[0].Phone,
            "Logo": dataPriceListInfo[0].Logo,
            "Registervn": dataPriceListInfo[0].Registervn,
            "Registeren": text,
            "Note": dataPriceListInfo[0].Note
        }, { headers: header }).then(res => {
            if (res.status === 200) {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });
                form.resetFields();
                LoadDataPriceListInfo();
            }
        })
    }

    return (
        <div>
            <Card bordered title={
                <Row>
                    <Col span={12}>
                        <span>
                            Chỉnh sửa mẫu EN
                        </span>
                    </Col>
                    <Col style={{ textAlign: 'right' }} span={12}>
                        <Button.Group>
                            <Button htmlType="submit" form="formen" type="primary" icon={<SaveOutlined />} style={{ backgroundColor: "#26A69A", color: 'white' }}>Cập nhật</Button>
                            &nbsp;
                            <Button onClick={(e) => showModalContract(e)} icon={<EyeOutlined />} type="primary">Xem form đăng ký</Button>
                        </Button.Group>

                    </Col>

                </Row>
            }>
                <Row >
                    <Col span={24}>
                        <Form id="formen" form={form} onFinish={onFinish}>
                            <Form.Item hidden name={'ContractTemplate'}>
                                <Input value={text} />
                            </Form.Item>
                            <HtmlEditor
                                value={value}
                                onInit={(evt, editor) => {
                                    setText(editor.getContent({ format: 'html' }));
                                    form.setFieldsValue({
                                        ContractTemplate: editor.getContent({ format: 'html' })
                                    })
                                }}
                                onEditorChange={(newValue, editor) => {
                                    setValue(newValue);
                                    setText(editor.getContent({ format: 'html' }));
                                    form.setFieldsValue({
                                        ContractTemplate: editor.getContent({ format: 'html' })
                                    })
                                }}
                                ref={editorRef}
                                init={{
                                    height: 500,
                                    menubar: true,
                                    plugins: [
                                        "advlist", "anchor", "autolink", "charmap", "code",
                                        "help", "image", "insertdatetime", "link", "lists", "media",
                                        "preview", "searchreplace", "table", "visualblocks",
                                    ],
                                    toolbar: 'undo redo |fontselect |casechange blocks | bold italic backcolor | ' +
                                        'alignleft aligncenter alignright alignjustify | ' +
                                        'bullist numlist checklist outdent indent | removeformat | a11ycheck code table help',
                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif,Times New Roman; font-size:14px }',
                                    encoding: 'xml',
                                    entity_encoding: 'raw',
                                    entities: '160,nbsp',
                                   
                                }}
                            />
                        </Form>

                    </Col>
                </Row>

            </Card>

            <Modal
                width={1200}
                onOk={handleOkContract}
                onCancel={handleCancelContract}

                open={openModalContract}
                title={
                    <span>
                        Xem bảng đăng ký
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelContract} key="back" >
                        Hủy
                    </Button>,

                ]}
            >
                {loadingContract ? (
                    <>
                        <Skeleton loading={loadingContract} active />
                    </>
                ) : (
                    <>{
                        <Row style={{ border: '1px solid #FAFAFA' }}>

                            <Col span={24}>
                                <Row>
                                    <Col span={24}>
                                        <br />
                                    </Col>
                                    <Col span={24}>
                                        <div dangerouslySetInnerHTML={{
                                            __html: value
                                        }}></div>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>

                    }</>
                )}
            </Modal>
        </div>


    )
}

export default FormTemplateEN